import ModalContext from './modal-context';

class GalleryModalContext extends ModalContext {
	switchOut(otherContext) {
		const element = this.getElement();
		this.classList(element).add(this.fixedClass);
		if (this.linkListener) {
			this.linkListener.destroy();
		}
		if (this.clickListener) {
			this.clickListener.destroy();
		}
		this.threeStateTransition(element)
			.remove(this.activeClass)
			.then(() => {
				this.classList(element).remove(this.fixedClass);
				this.restoreOriginalPosition();
				return otherContext;
			})
			.then(() => {
				element.querySelector(this.dataSelector('content')).innerHTML = '';
			});
		return otherContext;
	}
}

export default GalleryModalContext;
